import React from 'react';
import { useTranslation } from 'react-i18next';

import { Pulldown } from 'jbc-front/components/icons';
import { monthConverter, monthYearFormat, isSelectingCurrentMonth } from 'src/utils/Dashboard';

import HoverText from './HoverText';

import styles from './ExpensesMonthly.scss';

const MonthlyExpenseMonthSelector = ({ handleChangeMonth, selectedDate, currentMonth, isConfirmed }) => {
  const { t, i18n } = useTranslation();

  return (
    <div className={styles.monthContainer}>
      <button
        id="prev-month"
        className={styles.previous}
        aria-label="previous"
        type="button"
        onClick={() => handleChangeMonth('prev')}
        disabled={selectedDate?.isFirst}
      >
        <Pulldown size={10} />
      </button>
      <div id="selected-month" className={styles.selectedMonth}>
        <div className={styles.monthName}>{monthYearFormat(selectedDate?.date, i18n)}</div>
        {monthConverter(selectedDate?.date, currentMonth, t)}
      </div>
      <button
        id="next-month"
        className={styles.next}
        aria-label="next"
        type="button"
        onClick={() => handleChangeMonth('next')}
        disabled={selectedDate?.isLatest}
      >
        <Pulldown size={10} />
        {isSelectingCurrentMonth(selectedDate?.date, currentMonth) &&
          !isConfirmed && <HoverText>{t('features.Dashbord.components.ExpensesMonthly.un_confirmed')}</HoverText>}
      </button>
    </div>
  );
};

export default MonthlyExpenseMonthSelector;
